import { Link } from "react-router-dom";

export default function Footer() {
  const goTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E0D8] bg-[#1A3622] text-[#FAF9F6]">
      <div className="oak-container py-16 md:py-24">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
          <div>
            <div className="flex items-center gap-2 font-heading font-extrabold text-2xl">
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#C17F59]" />
              Oakbridg
            </div>
            <p className="mt-4 max-w-md text-[15px] leading-relaxed text-[#FAF9F6]/70">
              A quiet, dependable web studio. We build proper websites for small businesses,
              freelancers, and independents — and we stick around to keep them running.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-[#FAF9F6]/50">Explore</p>
            <ul className="mt-4 space-y-2 text-[15px]">
              <li><button data-testid="footer-link-pricing" onClick={() => goTo("pricing")} className="hover:text-white transition">Packages</button></li>
              <li><button data-testid="footer-link-calculator" onClick={() => goTo("calculator")} className="hover:text-white transition">Calculator</button></li>
              <li><Link to="/projects" data-testid="footer-link-projects" className="hover:text-white transition">Projects</Link></li>
              <li><button data-testid="footer-link-process" onClick={() => goTo("process")} className="hover:text-white transition">How it works</button></li>
              <li><button data-testid="footer-link-faq" onClick={() => goTo("faq")} className="hover:text-white transition">FAQ</button></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-[#FAF9F6]/50">Talk to us</p>
            <ul className="mt-4 space-y-2 text-[15px]">
              <li>
                <button
                  data-testid="footer-cta"
                  onClick={() => goTo("inquiry")}
                  className="inline-flex items-center gap-2 rounded-full bg-[#C17F59] text-white px-5 h-10 text-sm font-medium transition-all hover:-translate-y-0.5 hover:bg-[#A86A45]"
                >
                  Start a project
                </button>
              </li>
              <li className="text-[#FAF9F6]/70">
                Replies within one working day.
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-[13px] text-[#FAF9F6]/50">
          <p>© {year} Oakbridg. Built properly.</p>
          <p>Prices shown in your local currency are estimates. Final invoice is GBP.</p>
        </div>
      </div>
    </footer>
  );
}
